import type { AttractionType } from '@/config/objects/attraction-types';
import { useOutletContext } from 'react-router-dom';

interface AttractionTypeContext {
  attractionType: AttractionType | undefined;
  isLoading: boolean;
}

export function useAttractionTypeContext() {
  return useOutletContext<AttractionTypeContext>();
}
